import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "@/components/site/Logo";
import { EASE, SHOW_INTRO } from "@/lib/motion";

const Counter = () => {
  const [n, setN] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setN((v) => Math.min(100, v + 4)), 36);
    return () => clearInterval(id);
  }, []);
  return <span className="tabular-nums">{String(n).padStart(3, "0")}</span>;
};

export const Intro = () => {
  const [done, setDone] = useState(!SHOW_INTRO);
  useEffect(() => {
    sessionStorage.setItem("ed-intro", "1");
  }, []);
  if (done) return null;
  return (
    <motion.div
      data-testid="intro-overlay"
      aria-hidden="true"
      className="fixed inset-0 z-[100] flex flex-col justify-between bg-ink p-6 text-paper lg:p-12"
      initial={{ clipPath: "inset(0 0 0% 0)" }}
      animate={{ clipPath: "inset(0 0 100% 0)" }}
      transition={{ duration: 0.95, ease: EASE, delay: 1.05 }}
      onAnimationComplete={() => setDone(true)}
    >
      <div className="label flex justify-between text-paper/70">
        <span>Portfolio — 2026</span>
        <Counter />
      </div>
      <motion.div className="flex items-center gap-4" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }}>
        <LogoMark inverted className="h-10 w-10 sm:h-14 sm:w-14" />
        <span className="font-display text-2xl font-medium tracking-[-0.03em] sm:text-4xl">Eldiiar Dzhumagaziev</span>
      </motion.div>
      <div className="label flex justify-between text-paper/70">
        <span>Brand &amp; Multidisciplinary Design</span>
        <span>Hertfordshire, UK</span>
      </div>
    </motion.div>
  );
};
